export default __webpack_public_path__ + "static/media/cluster_8.e079c40d.jpg";